export default __webpack_public_path__ + "static/media/sugarcane.05f19831.png";